import { ReactElement } from "react";
import { FixedSizeList as List } from "react-window";

import { UIGraphNode } from "../types/graph";
import { SidebarHeading } from "./catalyst/SidebarHeading";
import { GraphConnectionItem } from "./GraphConnectionItem";

interface ConnectionsSectionProps {
  icon: ReactElement;
  items: Array<
    {
      entityName?: string;
    } & UIGraphNode["data"]
  >;
  title: string;
}

const ROW_HEIGHT = 56;
const VISIBLE_ROWS = 2;
const LIST_HEIGHT = ROW_HEIGHT * VISIBLE_ROWS;

export const GraphConnectionsSection = ({
  icon,
  items,
  title,
}: ConnectionsSectionProps): ReactElement => (
  <div className="overflow-y-hidden border-b border-b-zinc-800 p-4 pt-2 last:border-b-0">
    {title && (
      <SidebarHeading className="!mb-2 flex items-center !p-0">
        {icon}
        {title}
      </SidebarHeading>
    )}

    <List
      className="nice-scrollbar h-full overflow-y-auto"
      height={LIST_HEIGHT}
      itemCount={items.length}
      itemSize={ROW_HEIGHT}
      width="100%"
    >
      {({ index, style }) => {
        const item = items[index];

        if (!item) {
          return null;
        }

        return (
          <div style={style}>
            <GraphConnectionItem item={item} key={item.id} />
          </div>
        );
      }}
    </List>
  </div>
);
